export * from './home.component';


// WEBPACK FOOTER //
// ./src/app/home/index.ts